import { forwardRef } from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import Box from '@mui/material/Box';
import InputLabel, { InputLabelProps } from '@mui/material/InputLabel';
import { styled, Tooltip } from '@mui/material';

export const StyledInputLabel = styled(InputLabel)<InputLabelProps>(
    ({ theme }) => ({
        '&.MuiInputLabel-root': {
            color: theme.palette.secondary.dark,
            fontSize: '10px',
            margin: '0 0 5px 15px',
            '.MuiInputLabel-asterisk': {
                color: theme.palette.error.main,
            },
        },
    }),
);

const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
    '&.MuiTextField-root': {
        '.MuiInputBase-formControl': {
            // background: theme.palette.background.default,
            backgroundColor: '#ECEFF6 !important',
            borderRadius: 10,
        },

        '.MuiInputBase-formControl.MuiOutlinedInput-root': {
            // border: `1px solid ${theme.palette.grey[200]}`,
            border: 'none',
            minHeight: 'clamp(24px, 10vw,40px)',
        },

        '.MuiOutlinedInput-root': {
            padding: '15px 20px',
            background: theme.palette.background.default,
        },

        '.Mui-focused.MuiOutlinedInput-root': {
            // border: `1px solid ${theme.palette.primary.main}`
            border: 'none',
        },

        '.MuiInputBase-colorError.MuiOutlinedInput-root': {
            border: `1px solid ${theme.palette.error.main}`,
        },

        '& label.Mui-focused': {
            color: 'white',
            fontWeight: 'bold',
            fontSize: 14,
        },
        '& label': {
            color: theme.palette.primary.light,
            fontWeight: 'bold',
            fontSize: 18,
        },
        '.MuiInputBase-input': {
            color: theme.palette.secondary.main,
            fontSize: 14,
            fontWeight: 500,
            // background: theme.palette.background.default,
            borderRadius: 10,
            border: 'none',
            padding: '2px 8px 3px 5px',
            '& fieldset': {
                border: 'none',
            },
            '&:hover fieldset': {
                border: 'none',
            },
            '&.Mui-focused fieldset': {
                border: 'none',
            },
        },

        fieldset: {
            border: 'none',
        },

        '.Mui-focused fieldset': {
            border: 'none',
        },
        '& .MuiOutlinedInput-root': {
            border: 'none',
            '& .MuiOutlinedInput-input fieldset': {
                border: 'none',
            },
            '&:hover fieldset': {
                border: 'none',
            },
            '&.Mui-focused fieldset': {
                border: 'none',
            },

            '& input[type=number]': {
                // '-moz-appearance': 'textfield'
            },
            '& input[type=number]::-webkit-outer-spin-button': {
                // '-webkit-appearance': 'none',
                margin: 0,
            },
            '& input[type=number]::-webkit-inner-spin-button': {
                // '-webkit-appearance': 'none',
                margin: 0,
            },
        },
    },
}));

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const FormField = forwardRef<any, TextFieldProps>(
    (
        {
            label,
            type,
            error = false,
            helperText = '',
            required = false,
            onFocus,
            // onBlur,
            onMouseEnter,
            onMouseLeave,
            ...props
        },
        ref,
    ) => {
        return (
            <Tooltip title={props.inputProps?.tooltip}>
                <Box>
                    {label && (
                        <StyledInputLabel
                            sx={{ mb: 0 }}
                            error={error}
                            required={required}
                            color={props.color}
                        >
                            {label.toString().toLocaleUpperCase()}
                        </StyledInputLabel>
                    )}
                    <StyledTextField
                        type={type}
                        color={error ? 'error' : 'primary'}
                        label={undefined}
                        ref={ref}
                        inputProps={{
                            ...props.inputProps,
                            autoComplete: 'off',
                        }}
                        {...props}
                        value={props.value ?? ''}
                    />
                    <Box
                        sx={{
                            mt: 1,
                            color: (theme) => theme.palette.error.main,
                            fontSize: 12,
                            fontWeight: 600,
                        }}
                    >
                        { error && helperText}
                    </Box>
                </Box>
            </Tooltip>
        );
    },
);

FormField.displayName = 'FormField';
export default FormField;
